import React from "react";
import { Stack, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";

const BasicInfoSection = ({
  name,
  setName,
  description,
  setDescription,
  typeLabel,
}: {
  name: string;
  setName: (v: string) => void;
  description: string;
  setDescription: (v: string) => void;
  typeLabel: string;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("promotion_edit.basic_info.title")}
      rows={[
        {
          label: t("promotion_edit.basic_info.form.name.label"),
          required: true,
          children: (
            <TextField
              size="small"
              placeholder={t("promotion_edit.basic_info.form.name.placeholder")}
              sx={{ width: "50%" }}
              value={name}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setName(e.target.value)
              }
            />
          ),
        },
        {
          children: (
            <Stack direction="column" spacing={2}>
              <Typography>{typeLabel}</Typography>
              <Typography>
                {t("promotion_edit.basic_info.form.type.description")}
              </Typography>
            </Stack>
          ),
        },
        {
          label: t("promotion_edit.basic_info.form.description.label"),
          children: (
            <TextField
              size="small"
              multiline
              rows={4}
              placeholder={t(
                "promotion_edit.basic_info.form.description.placeholder",
              )}
              fullWidth
              value={description}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setDescription(e.target.value)
              }
            />
          ),
        },
      ]}
    />
  );
};

export default BasicInfoSection;
